/** @import * as PendulumApi from "#app_lib/pendulum_api.ts" */

/** @param {unknown} value */
const getValidString = (value) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);

/** @param {unknown} value */
const getValidPropertyValue = (value) => {
  if (typeof value === "string") {
    return getValidString(value);
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }

  if (typeof value === "boolean") {
    return String(value);
  }

  return undefined;
};

/**
 * @param {Record<string, PendulumApi.PostEventPropertyValue> | undefined} properties
 * @returns {Record<string, string>}
 */
const getValidProperties = (properties) =>
  Object.fromEntries(
    Object.entries(properties ?? {}).flatMap(([key, value]) => {
      const validKey = getValidString(key);
      const validValue = getValidPropertyValue(value);

      if (validKey === undefined || validValue === undefined) {
        return [];
      }

      return [[validKey, validValue]];
    }),
  );

/** @returns {PendulumApi.PendulumAnalyticsApi} */
const _PENDULUM_ANALYTICS_API = () => {
  /**
   * Initialize Analytics API
   * @param {unknown} [email]
   */
  const init = (email) => {
    const validEmail = getValidString(email);

    if (globalThis.api.analytics.email !== undefined) {
      return;
    }

    if (validEmail !== undefined) {
      globalThis.api.analytics.email = validEmail;
    }
  };

  /**
   *
   * @param {PendulumApi.PostEventParams} params
   */
  const postEvent = async (params) => {
    // TODO: decide if we want to send events in localdev mode
    // currently, throws cors errors
    if (globalThis.location.origin === "http://127.0.0.1:9292") {
      return;
    }
    const event = getValidString(params?.event);
    const customer_id = getValidString(globalThis.ShopifyAnalytics?.meta?.page?.customerId);
    const analytics_id = getValidString(globalThis.ShopifyAnalytics?.lib?.user?.()?.traits()?.uniqToken);
    const heap_id = getValidString(globalThis.heap?.getUserId());
    const email = getValidString(globalThis.api.analytics.email);
    const identity = getValidString(params?.identity) ?? email;
    const session_id = getValidString(params?.session_id);
    const user_id = customer_id ?? heap_id ?? analytics_id ?? getValidString(params?.user_id);
    const properties = getValidProperties({ ...params?.properties, analytics_id, customer_id, heap_id });

    if (event === undefined || (identity === undefined && session_id === undefined && user_id === undefined)) {
      return;
    }

    const paramsWithIds = {
      event,
      ...(identity === undefined ? {} : { identity }),
      ...(session_id === undefined ? {} : { session_id }),
      ...(user_id === undefined ? {} : { user_id }),
      ...(Object.keys(properties).length === 0 ? {} : { properties }),
    };
    try {
      await fetch(`${globalThis.api.analytics.constants.ANALYTICS_API_ROOT}/event`, {
        method: "POST",
        body: JSON.stringify(paramsWithIds),
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (e) {
      console.error("Failed to post event", e);
    }
  };

  return {
    constants: {
      ANALYTICS_API_ROOT: "https://analytics-drab-seven.vercel.app",
    },
    email: undefined,
    init,
    isInit: false,
    postEvent,
  };
};

globalThis.api = {
  analytics: _PENDULUM_ANALYTICS_API(),
};
